import DatePicker from "@hassanmojab/react-modern-calendar-datepicker";
import {
  Card,
  FormControlLabel,
  Grid,
  Icon, Radio,
  RadioGroup,
} from "@mui/material";
import { getRequestGroup, getReservationListByDate, getReservationNoteBook } from "api/routes";
import Loading from "components/Loading";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import queryString from "components/queryString";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import moment from "jalali-moment";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import MDButton from "../../components/MDButton";
import NoteBookTable from "./NoteBookTable";
import { getReservationNotebookStats } from "api/routes";

export default function ReservationNotebook() {
  const [loading, setLoading] = useState(false);
  const [reservationList, setReservationList] = useState([]);
  const [selectedDate, setSelectedDate] = useState({
    day: parseInt(moment().locale("fa").format("D")),
    month: parseInt(moment().locale("fa").format("M")),
    year: parseInt(moment().locale("fa").format("YYYY")),
  });
  const [reservationNoteBook, setReservationNoteBook] = useState([]);
  const [requestGroupData, setRequestGroupData] = useState([]);
  const [clickedRequestGroupId, setClickedRequestGroupId] = useState(13);

  const navigate = useNavigate();
  const m = moment();
  const renderCustomInput = ({ ref }) => (
    <div ref={ref} style={{
      position: "relative",
    }}>
      <p style={{
        position: "absolute", fontSize: 16, top: "-25px",
        width: "100%",
        textAlign: "center",
      }}>
        {moment(`${selectedDate.year}${String(selectedDate.month).padStart(2, "0")}${String(selectedDate.day).padStart(2, "0")}`, "jYYYYjMMjDD").locale("fa").format("dddd")}
      </p>
      <input
        readOnly
        placeholder="تاریخ"
        value={`${selectedDate.year}/${selectedDate.month}/${selectedDate.day}`}
        style={{
          outline: "none", textAlign: "center",
          border: "1px solid #49a3f1",
          borderRadius: 100,
          color: "#495057",
          cursor: "pointer",
          height: "44.3px",
          boxShadow: "0 0.5rem 1rem rgba(73, 163, 241, 0.2)",
          width: "150px",
          fontFamily: "IRANSansX",
        }}
      />
    </div>
  );
  const timeToMinutes = (time) => {
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
  };

  // Custom sort function
  useEffect(() => {
    setLoading(true);
    const FORMATTED_DATE = `${selectedDate.year}${String(selectedDate.month).padStart(2, "0")}${String(selectedDate.day).padStart(2, "0")}`;
    const query = {
      isNoteBook: 1,
      requestGroupId: clickedRequestGroupId,
    };
    getReservationListByDate(queryString(query), FORMATTED_DATE, (isOk, data) => {
      if (!isOk) {
        setLoading(false);
        return toast.error(data.message);
      } else {

        const sorted =
          data.sort((a, b) => {
            const startTimeA = timeToMinutes(a.startTime);
            const startTimeB = timeToMinutes(b.startTime);
            const startTime7AM = timeToMinutes("00:00");

            // Adjust times to start from 00:00
            const adjustedA = startTimeA < startTime7AM ? startTimeA + 24 * 60 : startTimeA;
            const adjustedB = startTimeB < startTime7AM ? startTimeB + 24 * 60 : startTimeB;

            return adjustedA - adjustedB;
          });
        return setReservationList(data);
      }
    });
    let query2 = {
      date: FORMATTED_DATE,
      all: 1,
      requestGroupId: clickedRequestGroupId,
    };

    getReservationNoteBook(queryString(query2), (isOk, data) => {
      if (!isOk) {
        setLoading(false);
        return toast.error(data.message);
      } else {
        setLoading(false);
        return setReservationNoteBook(data.data);
      }
    });
  }, [selectedDate, clickedRequestGroupId]);

  useEffect(() => {
    const query = {
      all: 1,
    };
    getRequestGroup((isOk, data) => {
      if (!isOk) return toast.error(data.message);
      else return setRequestGroupData(data);
    }, queryString(query));
  }, []);


  const onChangeDateWithArrow = (type) => {
    let NEW_DATE;
    const FORMATTED_DATE = `${selectedDate.year}${String(selectedDate.month).padStart(2, "0")}${String(selectedDate.day).padStart(2, "0")}`;

    if (type === "subtract") {
      NEW_DATE = moment(FORMATTED_DATE, "jYYYYjMMjDD").locale("fa").subtract(1, "d").format("jYYYYjMMjDD");
    } else NEW_DATE = moment(FORMATTED_DATE, "jYYYYjMMjDD").locale("fa").add(1, "d").format("jYYYYjMMjDD");
    setSelectedDate({
      day: parseInt(String(NEW_DATE).slice(6)),
      month: parseInt(String(NEW_DATE).slice(4, 6)),
      year: parseInt(String(NEW_DATE).slice(0, 4)),
    });
  };
  return (
    <>
      <DashboardLayout>
        <Loading loading={loading} />
        <MDBox pt={2}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <div>
                  <MDBox
                    mx={2}
                    mt={-3}
                    py={3}
                    px={2}
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                    style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                  >
                    <MDTypography variant="h6" color="white">
                      دفتر نوبت دهی
                    </MDTypography>
                    <DashboardNavbar />
                  </MDBox>
                  <MDButton style={{ color: "white", width: 200, borderRadius: 20, margin: "1rem 1rem 0 0" }}
                    onClick={() => navigate("/reservationNotebook/viewNotebook?collapseNavbar=1")}
                    variant="gradient"
                    color="warning">
                    مشاهده جزئیات دفتر
                  </MDButton>
                  <MDButton style={{ color: "white", borderRadius: 20, padding: "0 1rem", margin: "1rem 1rem 0 0" }}
                    onClick={() => navigate("/noteBookFullView?hideSideNav=1")}
                    variant="gradient"
                    color="primary">
                    تمام صفحه
                  </MDButton>
                  <MDBox pt={3} px={2} display="flex" justifyContent={"space-between"}>
                    <div style={{ marginLeft: 10, cursor: "pointer" }}>
                      <Icon fontSize="large"
                        onClick={() => onChangeDateWithArrow("subtract")}
                        style={{ color: "rgb(62, 205, 219)" }}>navigate_next</Icon>
                    </div>
                    <DatePicker
                      value={selectedDate}
                      onChange={setSelectedDate}
                      renderInput={renderCustomInput}
                      selectorStartingYear={Number(m?.locale("fa")?.format("YYYY"))}
                      selectorEndingYear={Number(m?.locale("fa")?.format("YYYY")) + 1}
                      shouldHighlightWeekends
                      locale="fa"
                      calendarPopperPosition={"bottom"}
                      colorPrimary="#0fbcf9"
                      colorPrimaryLight="rgba(75, 207, 250, 0.4)"
                    />
                    <Icon fontSize="large"
                      onClick={() => onChangeDateWithArrow("add")}
                      style={{ cursor: "pointer", color: "rgb(62, 205, 219)" }}>chevron_left</Icon>
                  </MDBox>
                </div>
                <RadioGroup row value={clickedRequestGroupId} style={{ marginRight: 30 }}
                  onChange={(event) => setClickedRequestGroupId(event.target.value)}
                >
                  {requestGroupData.map((item) => item.isNoteBook &&
                    <FormControlLabel key={item.requestGroupId} control={<Radio size={"small"} />} value={item.requestGroupId}
                      label={item.nameGroup} />,
                  )}
                </RadioGroup>
                <NoteBookTable reservationNoteBook={reservationNoteBook} setReservationNoteBook={setReservationNoteBook}
                  selectedDate={selectedDate}
                  data={reservationList} />
              </Card>
            </Grid>
          </Grid>
        </MDBox>
        <Footer />
      </DashboardLayout>
    </>
  );
}
